import { RegisterForm } from "@/components/auth/RegisterForm";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { PublicOnlyRoute } from "@/components/layout/PublicOnlyRoute";
import { SEO } from "@/components/common/SEO";

const Register = () => {
  return (
    <PublicOnlyRoute>
      <div className="flex flex-col min-h-screen">
        <SEO 
          title="Create Account"
          description="Join IntelliStitch to create custom knitting patterns, save your favorites, and connect with fellow knitters."
          type="website"
        />
        <Navbar />
        <main className="flex-1 flex flex-col items-center justify-center p-6 yarn-texture py-10">
          <div className="w-full max-w-md">
            <RegisterForm />
          </div>
        </main>
        <Footer />
      </div>
    </PublicOnlyRoute>
  );
};

export default Register;
